import React, { useContext, useEffect, useState } from 'react';
import '../createSurvey.css';
import Navbar from '../../../components/navbar/Navbar';
import Steps from '../../../components/steps';
import { Button } from '@mui/material';
import SingleSliderThree from '../SingleSliderThree';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../components/navbar/Footer';
import { StepsContext } from '../../../context/stepsContext';
import Pickles from '../../../components/particles/Pickles';
import {
  financialQuestion,
  professionalQuestion,
  physicalQuestion,
  mentalQuestion,
  socialQuestion,
  societalQuestion,
} from '../../../questions';
import { REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER } from '../../../config';
export default function StepThree({ minutesDisplay, secondsDisplay }) {
  const { state: stepThree } = useLocation();
  const { state } = stepThree;
  const { feeling } = stepThree;
  const { stepone } = stepThree;
  const { survey_id } = stepThree;
  const { keyAreaTopTexts } = stepThree;
  const { selectedConstructsTop } = stepThree;
  const { selectedConstructsBottom } = stepThree;
  const { selectedAbilities } = stepThree;
  const { personType } = stepThree;
  const { selectedCostitems } = stepThree;
  const { selected } = stepThree;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [financial, setfinancial] = useState({
    id: 1,
    name: 'Financial',
    question1: financialQuestion.question1,
    question2: financialQuestion.question2,
    value1: financialQuestion.value1,
    value2: financialQuestion.value2,
    altered: false,
    altered2: false,
  });
  const [professional, setprofessional] = useState({
    id: 2,
    name: 'Professional',
    question1: professionalQuestion.question1,
    question2: professionalQuestion.question2,
    value1: professionalQuestion.value1,
    value2: professionalQuestion.value2,
    altered: false,
    altered2: false,
  });
  const [physical, setphysical] = useState({
    id: 3,
    name: 'Physical',
    question1: physicalQuestion.question1,
    question2: physicalQuestion.question2,
    value1: physicalQuestion.value1,
    value2: physicalQuestion.value2,
    altered: false,
    altered2: false,
  });
  const [mental, setmental] = useState({
    id: 4,
    name: 'Mental',
    question1: mentalQuestion.question1,
    question2: mentalQuestion.question2,
    value1: mentalQuestion.value1,
    value2: mentalQuestion.value2,
    altered: false,
    altered2: false,
  });
  const [social, setsocial] = useState({
    id: 5,
    name: 'Social',
    question1: socialQuestion.question1,
    question2: socialQuestion.question2,
    value1: socialQuestion.value1,
    value2: socialQuestion.value2,
    altered: false,
    altered2: false,
  });
  const [societal, setsocietal] = useState({
    id: 6,
    name: 'Societal',
    question1: societalQuestion.question1,
    question2: societalQuestion.question2,
    value1: societalQuestion.value1,
    value2: socialQuestion.value2,
    altered: false,
    altered2: false,
  });
  let newArr = [];
  let allServices = newArr.concat(
    financial,
    professional,
    social,
    societal,
    mental,
    physical
  );
  let Altered = allServices.some((obj) => obj.altered === false);
  let Altered2 = allServices.some((obj) => obj.altered2 === false);

  const navigate = useNavigate();
  const { dispatch, start } = useContext(StepsContext);
  useEffect(() => {
    if (!start) navigate('/pageNotfound');
  }, [start, navigate]);

  let physical_wellbeing = physical.value1;
  let professional_wellbeing = professional.value1;
  let social_wellbeing = social.value1;
  let financial_wellbeing = financial.value1;
  let mental_wellbeing = mental.value1;
  let societal_wellbeing = societal.value1;
  let physical_wellbeing_support = physical.value2;
  let professional_wellbeing_support = professional.value2;
  let social_wellbeing_support = social.value2;
  let financial_wellbeing_support = financial.value2;
  let mental_wellbeing_support = mental.value2;
  let societal_wellbeing_support = societal.value2;
  const stepThreeDatas = {
    physical_wellbeing: physical_wellbeing,
    professional_wellbeing: professional_wellbeing,
    social_wellbeing: social_wellbeing,
    financial_wellbeing: financial_wellbeing,
    societal_wellbeing: societal_wellbeing,
    mental_wellbeing: mental_wellbeing,
    physical_wellbeing_support: physical_wellbeing_support,
    social_wellbeing_support: social_wellbeing_support,
    societal_wellbeing_support: societal_wellbeing_support,
    mental_wellbeing_support: mental_wellbeing_support,
    professional_wellbeing_support: professional_wellbeing_support,
    financial_wellbeing_support: financial_wellbeing_support,
  };

  const [pickle, setPickle] = useState(false);
  const handleClickNav = () => {
    setPickle(true);
    setTimeout(() => {
      setPickle(false);
      dispatch({ type: 'STEP' });
      navigate('/stepthree-2', {
        state: {
          state: state,
          feeling: feeling,
          personType: personType,
          stepone: stepone,
          stepThree: stepThreeDatas,
          keyAreaTopTexts: keyAreaTopTexts,
          selectedConstructsTop: selectedConstructsTop,
          selectedConstructsBottom: selectedConstructsBottom,
          selectedAbilities: selectedAbilities,
          selectedCostitems: selectedCostitems,
          selected: selected,
          survey_id: survey_id,
        },
      });
    }, 1000);
  };

  return (
    <div className="mainContainer">
      <Navbar
        special={
          REACT_APP_SURVEY_ID === survey_id ||
          REACT_APP_SURVEY_ID_ER === survey_id
        }
        minutesDisplay={minutesDisplay}
        secondsDisplay={secondsDisplay}
      />

      {pickle && <Pickles />}
      <div className="surveys-sub-container">
        <Steps er={REACT_APP_SURVEY_ID_ER === survey_id} step={3} active />
        <div className="inst-sub">
          <div className="link-sub">
            So that we can invest in the right wellbeing solutions we'd like to
            know how you feel about different aspects of your wellbeing. Please
            read the statements below and reflect how you feel against each.
          </div>
          <div className="link-sub">
            If you are struggling with any aspects of your wellbeing, we would
            encourage you to speak to your manager or a wellbeing representative
            immediately. If you would like independent help, there are resources
            available on our website.
          </div>
        </div>
        <div className="surveys-question-container surveys-question-container-two survey-slider-container">
          <div className="surveyServices">
            <div className="slider-all">
              <SingleSliderThree value={financial} setValues={setfinancial} />
              <SingleSliderThree
                value={professional}
                setValues={setprofessional}
              />
              <SingleSliderThree value={physical} setValues={setphysical} />
              <SingleSliderThree value={mental} setValues={setmental} />
              <SingleSliderThree value={social} setValues={setsocial} />
              <SingleSliderThree value={societal} setValues={setsocietal} />
            </div>
          </div>
        </div>
        <div className="btn-container">
          {/* <Link to={'/stepthree-2'}> */}
          <Button
            // disabled={Altered || Altered2}
            onClick={handleClickNav}
            className="signupCVbtnSign"
            type="submit"
            variant="contained"
            style={{
              backgroundColor: Altered || Altered2 ? '' : '#2691a3',
            }}
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              padding: '8px 30px',
              textTransform: 'capitalize',
              backgroundColor: '#2691a3',
              '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                backgroundColor: '#2691a3',
              },
            }}
          >
            Next
          </Button>
          {/* </Link> */}
        </div>

        <Footer />
      </div>
    </div>
  );
}
